import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {searchNoticeUsers} from '../../store/actions/userNoticesActions';
import './NoticeUserPicker.scss';

const selector = state => {
    const {language, userNotices} = state;
    return {
        t: language.translator,
        users: userNotices.users
    };
};

// Type 2+ characters (name, e-mail, login or exact id), pick a user from the list.
const NoticeUserPicker = ({onSelect, placeholder}) => {
    const {t, users} = useSelector(selector);
    const dispatch = useDispatch();
    const [query, setQuery] = useState('');

    useEffect(() => {
        const timer = setTimeout(() => dispatch(searchNoticeUsers(query)), 300);
        return () => clearTimeout(timer);
    }, [query, dispatch]);

    const choose = user => {
        onSelect(user);
        setQuery('');
        dispatch(searchNoticeUsers(''));
    };

    return (
        <div className='noticeUserPicker'>
            <span className='material-icons noticeUserPickerIcon'>search</span>
            <input
                value={query}
                onChange={event => setQuery(event.target.value)}
                placeholder={placeholder || t.gettext('Search user')}
            />
            {query.trim().length >= 2 && users.length > 0 &&
                <div className='noticeUserPickerResults'>
                    {users.map(user => (
                        <button
                            type='button'
                            key={user.id}
                            className='noticeUserPickerResult'
                            onClick={() => choose(user)}
                        >
                            <span className='noticeUserPickerName'>{user.name || user.email}</span>
                            <span className='noticeUserPickerEmail'>
                                {user.email} · #{user.id}
                            </span>
                        </button>
                    ))}
                </div>
            }
        </div>
    );
};

export default NoticeUserPicker;
